import InvestorDescriptionsApi from '../../../core/api/InvestorDescriptionsApi'
export const FETCHING_INVESTOR_DESCRIPTIONS = 'FETCHING_INVESTOR_DESCRIPTIONS'
export const FETCH_INVESTOR_DESCRIPTIONS = 'FETCH_INVESTOR_DESCRIPTIONS'

export const fetchingInvestorDescriptions = service => ({
  type: FETCHING_INVESTOR_DESCRIPTIONS
})

export function fetchInvestorDescriptions () {
  const api = new InvestorDescriptionsApi()
  

  return async (dispatch) => {
    try{
      const response = await api.fetchingInvestorDescriptions()
      dispatch({
        type: FETCH_INVESTOR_DESCRIPTIONS,
        payload: response
      })
      return response
    } catch (error){
      dispatch({
        type: FETCH_INVESTOR_DESCRIPTIONS,
        payload: []
      })
      throw error
    }
    
  }
}
